export default "__VITE_ASSET__CoFjNLF5__"